import { useEffect } from 'react';

// Test notifications are suppressed - results are logged to database only
// See test_run_logs table for test history
export const useTestNotifications = () => {
  useEffect(() => {
    // Notifications suppressed per user request
    // Test results are stored in test_run_logs table and visible in admin dashboard
  }, []);
};
